import { productDetailDate } from '../../../common/utils/productCreationUtil'

export const getTooltipDate = (
  xValue: string | number | Date | null | undefined,
  timeZone?: string
) => {
  if (!xValue) {
    return null
  }

  const dateValue = xValue instanceof Date ? xValue : new Date(String(xValue))

  if (Number.isNaN(dateValue.getTime())) {
    return null
  }

  return productDetailDate(dateValue, timeZone).modifiedDate
}
